import * as React from 'react';
import { Image } from '@cian/ui-kit';
import cx from 'classnames';
import * as styles from './styles.css';

export interface IBackgroundVideoProps {
  url: string;
  poster?: string;
}

export function BackgroundVideo({ url, poster }: IBackgroundVideoProps) {
  const [isLoaded, setLoadedState] = React.useState(false);
  const [isError, setErrorState] = React.useState(false);

  const onLoaded = React.useCallback(() => setLoadedState(true), []);
  const onError = React.useCallback(() => {
    setErrorState(true);
    setLoadedState(true);
  }, []);

  return (
    <div className={styles['container']}>
      <video className={styles['video']} playsInline autoPlay muted loop onCanPlayThrough={onLoaded} onError={onError}>
        <source src={url} type="video/mp4" />
      </video>
      <div className={cx(styles['poster'], isLoaded && !isError && styles['poster--hidden'])}>
        {poster && <Image src={poster} objectFit={'cover'} />}
      </div>
    </div>
  );
}
